import { Message } from 'element-ui'
import store from '../store'
// import parseTime, formatTime and set to filter
export { parseTime, formatTime, safeGet } from '@/utils'
export { cryptoJSAesDecrypt, cryptoJSAesEncrypt,
  strToAsterisk, strAesDecryptAndAsterisk, strAesDecryptAndEmailAsterisk } from '@/utils/encrypt'

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  if (Number.isNaN(Number(num))) {
    return
  }
  // 如果平台为印尼，则用.分隔，否则用,
  const separator = process.env.VUE_APP_PLATFORM === 'id' ? '.' : ','
  return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, separator)
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function format10000ToPercentile(num) {
  if (!Number(num) && num != 0) {
    return 0
  }

  // return num / 10000 * 100
  return num / 100
}

export function toDivide100(num) {
  if (!Number(num) && num != 0) {
    return 0
  }
  return num / 100
}

export function toDivideWithDot(num) {
  const divide100Num = +toDivide100(num)
  const withDotNumber = Number(divide100Num).toFixed(2)
  const currency = store.getters.currency
  if (['IDR', 'VND'].includes(currency) || process.env.VUE_APP_PLATFORM === 'id') {
    return toThousandFilter(divide100Num)
  } else {
    return toThousandFilter(withDotNumber)
  }
}

export function numWithDot(num) {
  const currency = store.getters.currency
  if (['IDR', 'VND'].includes(currency) || process.env.VUE_APP_PLATFORM === 'id') {
    if (!Number(num) && num != 0) {
      return 0
    }
    return toThousandFilter(num)
  }
  if (!Number(num) && num != 0) {
    return 0.00
  }
  const numDot = Number(num).toFixed(2)
  return toThousandFilter(numDot)
}
